import React, { ReactNode, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LinkToIcon from 'icons/LinkTo.icon';
import { CollapsibleSection } from 'components/CollapsibleSection';

import './SuggestedActionSection.styles.scss';

type SuggestedActionSectionProps = {
  className?: string;
  text: string;
  to: string;
  linkText: string;
  showEmptyState?: boolean;
  emptyStateText?: string;
  Icon?: ReactNode;
  isCollapsible?: boolean;
};

const SuggestedActionSection: React.FC<SuggestedActionSectionProps> = (
  props,
) => {
  const {
    children,
    className,
    text,
    to,
    linkText,
    showEmptyState,
    emptyStateText,
    Icon,
    isCollapsible = true,
  } = props;

  const classes = classNames('suggested-action-section', className);

  const { t } = useTranslation();

  const Title = useMemo(
    () => (
      <p className="title">
        {Icon && Icon}
        {text}
      </p>
    ),
    [Icon, text],
  );

  const EmptyState = useMemo(
    () =>
      showEmptyState && (
        <div className="empty-state-container">
          {emptyStateText || t('allCleared')}
        </div>
      ),
    [emptyStateText, showEmptyState, t],
  );

  const LinkTo = useMemo(
    () => (
      <Link className="link" to={to}>
        {linkText}
        <LinkToIcon />
      </Link>
    ),
    [linkText, to],
  );

  if (isCollapsible)
    return (
      <CollapsibleSection defaultOpen className={classes} trigger={Title}>
        {children}
        {EmptyState}
        {LinkTo}
      </CollapsibleSection>
    );

  return (
    <div className={classes}>
      {Title}
      {children}
      {EmptyState}
      {LinkTo}
    </div>
  );
};

export default SuggestedActionSection;
